<template>
    <div class="baimoc-card" :style="{height: card_height,paddingBottom: '0'}">
        <div style="padding: 20px 30px 0 30px">
            <div>
                <el-steps :active="active" finish-status="success">
                    <el-step title="Step 1" description="Input your Sequence or upload file"></el-step>
                    <el-step title="Step 2" description="Preview the data to be predicted"></el-step>
                    <el-step title="Step 3" description="Prediction"></el-step>
                </el-steps>
                <!-- <el-divider content-position="left">Input Gene expression matrix </el-divider> -->
                <el-row v-if="active==0" style="padding:0">
                    <hr style="margin: 10px 0 30px 0">
                    <el-form label-width="150px">
                        <el-form-item label="Input Sequence">
                            <el-input type="textarea" v-model="protein_seq" :rows="10"></el-input>
                        </el-form-item>
                        <el-form-item label="Or, Upload File">
                            <el-upload
                                    :action="upload_url"
                                    :on-success="handleAvatarSuccess"
                                    :on-remove="handleRemove"
                                    :before-remove="beforeRemove"
                                    :limit="1"
                                    :on-exceed="handleExceed"
                                    :file-list="fileList">
                                <el-button size="small" type="primary">Upload File</el-button>
                                <div slot="tip" class="el-upload__tip">Allow uploading of genes table file, and no more
                                    than 500kb
                                </div>
                            </el-upload>
                            <!-- ================================================= -->
                            <el-form-item>
                                <hr>
                                <el-button @click="next_step()" type="primary">Next Step</el-button>
                                <el-button @click="reset()" type="primary">Reset</el-button>
                            </el-form-item>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-row v-if="active==1" style="padding:0">
                    <hr style="margin: 10px 0 30px 0">
                    <el-form label-width="150px">
                        <el-form-item label="Sequences id">
                            <el-select v-model="seq_id_val" placeholder="Select Sequence id">
                                <el-option
                                        v-for="item in seq_id_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="Database">
                            <el-select v-model="protein_db_val" placeholder="Select Sequence id">
                                <el-option
                                        v-for="item in protein_db_options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="Organism">
                            <el-select v-model="value_organsim" placeholder="Select Organsim">
                                <el-option
                                        v-for="item in options_organsim"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="Algorithm">
                            <el-select v-model="value_algorithm" placeholder="Select Algorithm">
                                <el-option
                                        v-for="item in options_algorithm"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>

                        </el-form-item>
                        <el-form-item label="">
                            <el-collapse>
                                <el-collapse-item title="More Algorithm Parameters" name="1">
                                    <el-form label-width="163px">
                                        <el-form-item label="Max target sequences">
                                            <el-select v-model="max_target_sequences_val"
                                                       placeholder="Select Algorithm">
                                                <el-option
                                                        v-for="item in max_target_sequences_options"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                        <el-form-item label="Expect threshold">
                                            <el-select v-model="expect_threshold_val" placeholder="Select Algorithm">
                                                <el-option
                                                        v-for="item in expect_threshold_options"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                        <el-form-item label="Word size">
                                            <el-select v-model="word_size_val" placeholder="Select Algorithm">
                                                <el-option
                                                        v-for="item in word_size_options"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                        <el-form-item label="Gap Costs">
                                            <el-select v-model="gap_costs_val" placeholder="Select Algorithm">
                                                <el-option
                                                        v-for="item in gap_costs_options"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="Matrix">
                                            <el-select v-model="matrix_val" placeholder="Select Algorithm">
                                                <el-option
                                                        v-for="item in matix_options"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="Filter">
                                            <el-checkbox v-model="low_comlexity_regions">Low complexity regions
                                            </el-checkbox>
                                        </el-form-item>
                                        <el-form-item label="Mask">
                                            <el-checkbox v-model="mask_for_lookup_table_only">Mask for lookup table
                                                only
                                            </el-checkbox>
                                        </el-form-item>
                                        <el-form-item label="">
                                            <el-checkbox v-model="mask_lower_case_letters">Mask lower case letters
                                            </el-checkbox>
                                        </el-form-item>
                                    </el-form>
                                </el-collapse-item>
                            </el-collapse>
                        </el-form-item>
                        <!--<el-form-item label="Sequence">-->
                        <!--<el-input type="textarea" v-model="protein_seq" :rows="10"></el-input>-->
                        <!--</el-form-item>-->
                    </el-form>
                    <el-form label-width="150px">
                        <el-form-item>
                            <hr>
                            <el-button @click="submit()" type="primary">Submit</el-button>
                            <el-button @click="previous_step()">Previous Step</el-button>
                        </el-form-item>
                    </el-form>
                </el-row>
                <el-row v-if="active>=2" v-loading="loading2">
                    <el-card class="box-card" style="margin-bottom: 15px">
                    <div id="container" :style="{height: hits_chart_height}"></div>
                        <div v-if="hits_chart_height !== '0px'" style="padding-bottom: 25px">
                            <center>
                                <div class="col-md-offset-1 col-xs-offset-1 col-sm-offset-1 col-xs-2 col-sm-2 col-md-2 legend"
                                     style="background: #434348;">
                                    &lt;=40
                                </div>
                                <div class="col-xs-2 col-sm-2 col-md-2 legend" style="background: #7cb5ec;">
                                    40-50
                                </div>
                                <div class="col-xs-2 col-sm-2 col-md-2 legend" style="background: #90ed7d;">
                                    50-80
                                </div>
                                <div class="col-xs-2 col-sm-2 col-md-2 legend" style="background: #f999b0;">
                                    80-200
                                </div>
                                <div class="col-xs-2 col-sm-2 col-md-2 legend" style="background: #f45151;">
                                    &gt;=200
                                </div>
                                <div class="col-xs-1 col-sm-1 col-md-1 legend" style="background: #fff;">
                                </div>
                            </center>
                        </div>
                    </el-card>
                    <div v-if="JSON.stringify(blast_res) !== '{}'" >
                        <el-card class="box-card" style="margin-bottom: 15px"
                                 v-for="(hit, i) in blast_res['BlastOutput2'][0]['report']['results']['search']['hits']"
                                 :key="i" :id="hit['description'][0]['title'].split('|')[2]">
                            <div slot="header" class="clearfix">
                                <div>
                                    <i class="icon-font icon-yuan" :style="hit|score_color"></i>
                                    <h3 style="margin-top: 0px"><a href=""><b>{{hit["description"][0]["title"].split("|")[3]}}</b></a>
                                    </h3>
                                </div>
                                <h5 style="color:#8395a7">{{hit["description"][0]["title"].split("|")[2]}}
                                    ({{hit["description"][0]["title"].split("|")[1]}})</h5>
                                <!--<el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button>-->

                            </div>
                            <div>
                                <!--{{hit}}-->
                                <div v-for="(hsp, j) in hit['hsps']" :key="j">
                                    <el-table
                                            :data="[hsp]"
                                            border
                                            style="width: 100%">
                                        <el-table-column
                                                prop="score"
                                                label="Scores"
                                                width="180">
                                        </el-table-column>
                                        <el-table-column
                                                prop="evalue"
                                                label="Evalue"
                                                width="180">
                                        </el-table-column>
                                        <el-table-column
                                                prop="positive"
                                                label="Positives">
                                        </el-table-column>
                                        <el-table-column
                                                prop="align_len"
                                                label="align_len">
                                        </el-table-column>
                                        <el-table-column
                                                prop="identity"
                                                label="Identities">
                                        </el-table-column>
                                        <el-table-column
                                                prop="gaps"
                                                label="Gaps">
                                        </el-table-column>
                                    </el-table>

                                    <!--<pre>-->
                                    <!--{{hsp['query_from']}}{{hsp['qseq']}}{{hsp['query_to']}}<br>-->
                                    <!--{{hsp['midline']}}<br>-->
                                    <!--{{hsp['hit_from']}}{{hsp['hseq']}}{{hsp['hit_to']}}-->
                                    <!--</pre>-->
                                    <pre>{{hsp['qseq']}}<br>{{hsp['midline']}}<br>{{hsp['hseq']}}</pre>
                                </div>

                            </div>
                        </el-card>
                    </div>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
    // import axios from 'axios'
    import global_ from "../components/units/Global";
    import axios from 'axios';
    import Highcharts from 'highcharts'
    import gantt from 'highcharts/modules/gantt'

    gantt(Highcharts)
    export default {
        name: "ExpBrowser",
        data() {
            return {
                loading1: false,
                loading2: false,
                headers: {},
                genes_table_header: [],    // 请求头是个对象
                datas: {},        // 对象
                active: 0,
                tableData: [],
                prediction_table: [],
                preidction_label: [],
                prediction_stage: [],
                file_url: '',
                upload_url: '',
                jobid: "",
                hits_chart_height: "0px",
                website: global_.website,
                winHeight: window.innerHeight - 301 + "px",
                card_height: window.innerHeight - 180 + "px",
                table_height: window.innerHeight - 510,
                protein_seq: ">sp|P00698|LYSC_CHICK_Lysozyme_C_OS_Gallus_gallus_OX_9031_GN_LYZ_PE_1_SV_1\nKVFGRCELAAAMKRHGLDNYRGYSLGNWVCAAKFESNFNTQATNRNTDGSTDYGILQINSRWWCNDGRTPGSRNLCNIPCSALLSSDITASVNCAKKIVSDGNGMNAWVAWRNRCKGTDVQAWIRGC\n>sp|P61626|LYSC_HUMAN_Lysozyme_C_OS_Homo_sapiens_OX_9606_GN_LYZ_PE_1_SV_1\nKVFERCELARTLKRLGMDGYRGISLANWMCLAKWESGYNTRATNYNADRSTDYGIFQINSRYWCNDGKTPGAVNACHLSCSALLQDNIADAVACAKRVVRDPQGIRAWVAWRNRCQNRDVRQYVQGC\n>sp|P17897|LYZ1_MOUSE_Lysozyme_C-1_OS_Mus_musculus_OX_10090_GN_Lyz1_PE_1_SV_1\nKVYNRCELARILKRNGMDGYRGVKLADWVCLAQHESNYNTRATNYNRDRSTDYGIFQINSRYWCNDGKTPRSKNACGINCSALLQDDITAAIQCAKRVVRDPQGIRAWVAWRTQCQNRDLSQYIRNC\n>sp|P00697|LYSC1_RAT_Lysozyme_C-1_OS_Rattus_norvegicus_OX_10116_GN_Lyz1_PE_1_SV_2\nKIYERCQFARTLKRNGMSGYYGVSLADWVCLAQHESNYNTQARNYNPDQSTDYGIFQINSRYWCNDGKTPRAKNACGIPCSALLQDDITQAIQCAKRVVRDPQGIRAWVAWQRHCKNRDLSGYIRNC\n>sp|P08905|LYZ2_MOUSE_Lysozyme_C-2_OS_Mus_musculus_OX_10090_GN_Lyz2_PE_1_SV_2\nKVYERCEFARTLKRNGMAGYYGVSLADWVCLAQHESNYNTRATNYNRDQSTDYGIFQINSRYWCNDGKTPRAVNACGINCSALLQDDITAAIQCAKRVVRDPQGIRAWVAWRAHCQNRDLSQYIRNC\n>sp|P00703|LYSC_MELGA_Lysozyme_C_OS_Meleagris_gallopavo_OX_9103_GN_LYZ_PE_1_SV_2\nKVYGRCELAAAMKRLGLDNYRGYSLGNWVCAAKFESNFNTHATNRNTDGSTDYGILQINSRWWCNDGRTPGSKNLCNIPCSALLSSDITASVNCAKKIASGGNGMNAWVAWRNRCKGTDVHAWIRGC\n>sp|P00702|LYSC_PHACO_Lysozyme_C_OS_Phasianus_colchicus_colchicus_OX_9057_GN_LYZ_PE_1_SV_2\nKVYGRCELAAAMKRMGLDNYRGYSLGNWVCAAKFESNFNTGATNRNTDGSTDYGILQINSRWWCNDGRTPGSKNLCHIPCSALLSSDITASVNCAKKIVSDGNGMNAWVAWRKHCKGTDVNVWIRGC\n>sp|P00701|LYSC_COTJA_Lysozyme_C_OS_Coturnix_japonica_OX_93934_GN_LYZ_PE_1_SV_2\nKVYGRCELAAAMKRHGLDKYQGYSLGNWVCAAKFESNFNTQATNRNTDGSTDYGILQINSRWWCNDGRTPGSRNLCNIPCSALLSSDITASVNCAKKIVSDVHGMNAWVAWRNRCKGTDVNAWIRGC\n>sp|P61629|LYSC_PAPAN_Lysozyme_C_OS_Papio_anubis_OX_9555_GN_LYZ_PE_1_SV_1\nKIFERCELARTLKRLGLDGYRGISLANWVCLAKWESDYNTQATNYNPDQSTDYGIFQINSHYWCNNGKTPGAVNACHISCNALLQDNIADAVTCAKRVVSDPQGIRAWVAWRNHCQNRDVSQYVQGC\n>sp|P00705|LYSC1_ANAPL_Lysozyme_C-1_OS_Anas_platyrhynchos_OX_8839_PE_1_SV_1\nKVYSRCELAAAMKRLGLDNYRGYSLGNWVCAANYESGFNTQATNRNTDGSTDYGILQINSRWWCDNGKTPRSKNACGIPCSVLLRSDITEAVRCAKRIVSDGDGMNAWVAWRNRCRGTDVSKWIRGC\n>sp|P00704|LYSC_NUMME_Lysozyme_C_OS_Numida_meleagris_OX_8996_GN_LYZ_PE_1_SV_2\nKVFGRCELAAAMKRHGLDNYRGYSLGNWVCAAKFESNFNSQATNRNTDGSTDYGVLQINSRWWCNDGRTPGSRNLCNIPCSALQSSDITATANCAKKIVSDGNGMNAWVAWRKHCKGTDVRVWIKGC\n>sp|P00700|LYSC_COLVI_Lysozyme_C_OS_Colinus_virginianus_OX_9014_GN_LYZ_PE_1_SV_2\nKVFGRCELAAAMKRHGLDNYRGYSLGNWVCAAKFESNFNSQATNRNTDGSTDYGVLQINSRWWCNDGKTPGSRNLCNIPCSALLSSDITATVNCAKKIVSDGNGMNAWVAWRNRCKGTDVQAWIRGC\n>sp|P30201|LYSC_MACMU_Lysozyme_C_OS_Macaca_mulatta_OX_9544_GN_LYZ_PE_2_SV_1\nKIFERCELARTLKRLGLDGYRGISLANWVCLAKWESNYNTQATNYNPDQSTDYGIFQINSHYWCNNGKTPGAVNACHISCNALLQDNIADAVTCAKRVVSDPQGIRAWVAWRNHCQNRDVSQYVQGC\n>sp|Q7LZQ1|LYSC_PELSI_Lysozyme_C_OS_Pelodiscus_sinensis_OX_13735_GN_LYZ_PE_1_SV_3\nKIYEQCELAREFKRHGMDGYHGYSLGDWVCTAKHESNFNTAATNYNRDQSTDYGILQINSRWWCNDGKTPKAKNACGIECSELLKADITAAVNCAKRIVRDPNGMGAWVAWTKYCKGKDVSQWIKGC\n>sp|Q05820|LYSC2_RAT_Putative_lysozyme_C-2_OS_Rattus_norvegicus_OX_10116_GN_Lyz2_PE_5_SV_1\nKVFKHCELARILRSSALAGYRGVSLENWMCMAQHESNFDTEAINYNSDQSTDYGIFQINSRYWCNDGKTPRAVNACGIPCSALLQDDITQAIQCAKRVVRDPQGIRAWVAWQRHCQNRDLSGYIRNC\n>sp|P67980|LYSC_TRAFR_Lysozyme_C_OS_Trachypithecus_francoisi_OX_54180_GN_LYZ_PE_2_SV_1\nKIFERCELARTLKKLGLDGYKGVSLANWVCLAKWESGYNTEATNYNPDESTDYGIFQINSRYWCNNGKTPGAVDACHISCSALLQNNIADAVACAKRVVSDPQGIRAWVAWRNHCQNKDVSQYVKGC\n>sp|P67978|LYSC_TRAVT_Lysozyme_C_OS_Trachypithecus_vetulus_OX_54137_GN_LYZ_PE_3_SV_1\nKIFERCELARTLKKLGLDGYKGVSLANWVCLAKWESGYNTEATNYNPDESTDYGIFQINSRYWCNNGKTPGAVDACHISCSALLQNNIADAVACAKRVVSDPQGIRAWVAWRNHCQNKDVSQYVKGC\n>sp|P67979|LYSC_TRAOB_Lysozyme_C_OS_Trachypithecus_obscurus_OX_54181_GN_LYZ_PE_2_SV_1\nKIFERCELARTLKKLGLDGYKGVSLANWVCLAKWESGYNTEATNYNPDESTDYGIFQINSRYWCNNGKTPGAVDACHISCSALLQNNIADAVACAKRVVSDPQGIRAWVAWRNHCQNKDVSQYVKGC\n>sp|P61628|LYSC_PANTR_Lysozyme_C_OS_Pan_troglodytes_OX_9598_GN_LYZ_PE_2_SV_1\nKVFERCELARTLKRLGMDGYRGISLANWMCLAKWESGYNTRATNYNADRSTDYGIFQINSRYWCNDGKTPGAVNACHLSCSALLQDNIADAVACAKRVVRDPQGIRAWVAWRNRCQNRDVRQYVQGC\n>sp|P16973|LYSC_RABIT_Lysozyme_C_OS_Oryctolagus_cuniculus_OX_9986_GN_LYZ_PE_1_SV_1\nKIYERCELARTLKKLGLDGYKGVSLANWMCLAKWESSYNTRATNYNPDKSTDYGIFQINSRYWCNDGKTPRAVNACHIPCSDLLKDDITQAVACAKRVVSDPQGIRAWVAWRNHCQNQDLTPYIRGC\n>sp|P79294|LYSC_SAISC_Lysozyme_C_OS_Saimiri_sciureus_OX_9521_GN_LYZ_PE_2_SV_1\nKVFERCELARTLKRLGMDGYRGISLANWMCLAKWESDYNTRATNYNPDQSTDYGIFQINSHYWCNNGRTPGAVNACHISCNALLQDDITQAVACAKRVVRDPQGIRAWVAWKAHCQNRDVSQYVQGC",
                fileList: [],
                result_data: [],
                seq_id_options: [],
                seq_id_val: "",
                more_params: ['10', '10', '3', '11,1', 'BLOSUM62', 'false', 'false', 'false'],
                max_target_sequences_options: [
                    {
                        value: "10",
                        label: "10",
                    },
                    {
                        value: "50",
                        label: "50",
                    },
                    {
                        value: "100",
                        label: "100",
                    },
                    {
                        value: "250",
                        label: "250",
                    },
                    {
                        value: "500",
                        label: "500",
                    },
                    {
                        value: "1000",
                        label: "1000",
                    },
                ],
                max_target_sequences_val: "100",
                expect_threshold_options: [
                    {
                        value: "1",
                        label: "1",
                    },
                    {
                        value: "0.1",
                        label: "0.1",
                    },
                    {
                        value: "0.01",
                        label: "0.01",
                    },
                    {
                        value: "0.05",
                        label: "0.05",
                    },
                    {
                        value: "0.001",
                        label: "0.001",
                    },
                    {
                        value: "0.0001",
                        label: "0.0001",
                    },
                    {
                        value: "0.00001",
                        label: "0.00001",
                    },
                ],
                expect_threshold_val: '0.05',
                word_size_options: [
                    {
                        value: "2",
                        label: "2",
                    },
                    {
                        value: "3",
                        label: "3",
                    },
                    {
                        value: "4",
                        label: "4",
                    },
                    {
                        value: "5",
                        label: "5",
                    },
                    {
                        value: "6",
                        label: "6",
                    },
                    {
                        value: "7",
                        label: "7",
                    },
                    {
                        value: "8",
                        label: "8",
                    },
                    {
                        value: "9",
                        label: "9",
                    },
                    {
                        value: "10",
                        label: "10",
                    },
                    {
                        value: "11",
                        label: "11",
                    },
                    {
                        value: "12",
                        label: "12",
                    },
                    {
                        value: "13",
                        label: "13",
                    },
                    {
                        value: "14",
                        label: "14",
                    },
                    {
                        value: "15",
                        label: "15",
                    },
                    {
                        value: "16",
                        label: "16",
                    },
                    {
                        value: "17",
                        label: "17",
                    },
                    {
                        value: "18",
                        label: "18",
                    },
                    {
                        value: "19",
                        label: "19",
                    },
                    {
                        value: "20",
                        label: "20",
                    },
                    {
                        value: "21",
                        label: "21",
                    },
                    {
                        value: "22",
                        label: "22",
                    },
                    {
                        value: "23",
                        label: "23",
                    },
                    {
                        value: "24",
                        label: "24",
                    },
                    {
                        value: "25",
                        label: "25",
                    },
                    {
                        value: "26",
                        label: "26",
                    },
                    {
                        value: "27",
                        label: "27",
                    },
                    {
                        value: "28",
                        label: "28",
                    },
                    {
                        value: "29",
                        label: "29",
                    },
                    {
                        value: "30",
                        label: "30",
                    },
                ],
                word_size_val: "6",
                gap_costs_options: [
                    {
                        value: "11,2",
                        label: "11,2",
                    },
                    {
                        value: "10,2",
                        label: "10,2",
                    },
                    {
                        value: "9,2",
                        label: "9,2",
                    },
                    {
                        value: "8,2",
                        label: "8,2",
                    },
                    {
                        value: "7,2",
                        label: "7,2",
                    },
                    {
                        value: "6,2",
                        label: "6,2",
                    },
                    {
                        value: "13,1",
                        label: "13,1",
                    },
                    {
                        value: "12,1",
                        label: "12,1",
                    },
                    {
                        value: "11,1",
                        label: "11,1",
                    },
                    {
                        value: "10,1",
                        label: "10,1",
                    },
                    {
                        value: "9,1",
                        label: "9,1",
                    },

                ],
                gap_costs_val: "11,1",
                matix_options: [
                    {
                        value: "PAM30",
                        label: "PAM30",
                    },
                    {
                        value: "PAM70",
                        label: "PAM70",
                    },
                    {
                        value: "PAM250",
                        label: "PAM250",
                    },
                    {
                        value: "BLOSUM80",
                        label: "BLOSUM80",
                    },
                    {
                        value: "BLOSUM62",
                        label: "BLOSUM62",
                    },
                    {
                        value: "PAM45",
                        label: "PAM45",
                    },
                    {
                        value: "PAM50",
                        label: "PAM50",
                    },
                    {
                        value: "PAM90",
                        label: "PAM90",
                    },
                ],
                matrix_val: "BLOSUM62",
                low_comlexity_regions: false,
                mask_for_lookup_table_only: false,
                mask_lower_case_letters: false,
                protein_db_options: [
                    {
                        value: "All",
                        label: "All",
                    },
                    {
                        value: "AlphaFold Protein Structure Database (Prediction)",
                        label: "AlphaFold Protein Structure Database (Prediction)",
                    },
                    {
                        value: "Protein Data Bank (Review)",
                        label: "Protein Data Bank (Review)",
                    },
                ],
                protein_db_map: {
                    "All": "All",
                    "AlphaFold Protein Structure Database (Prediction)": "AlphaFold",
                    "Protein Data Bank (Review)": "PDB",
                },
                protein_db_val: "All",
                options_algorithm: [
                    {
                        value: "Quick BLASTP (Accelerated protein-protein BLAST)",
                        label: "Quick BLASTP (Accelerated protein-protein BLAST)",
                    },
                    {
                        value: "blastp (protein-protein BLAST)",
                        label: "blastp (protein-protein BLAST)",
                    },
                ],
                value_algorithm: "blastp (protein-protein BLAST)",
                organsim_map: {
                    'Homo sapiens (Human)': "9606",
                    'Mus musculus (Mouse)': "10090",
                    'Rattus norvegicus (Rat)': "10116",
                    'Danio rerio (Zebrafish)': "7955",
                    'Caenorhabditis elegans (Nematode worm)': "6239",
                    'Drosophila melanogaster (Fruit fly)': "7227",
                    'Arabidopsis thaliana (Arabidopsis)': "3702",
                    'Glycine max (Soybean)': "3847",
                    'Oryza sativa (Asian rice)': "39947",
                    'Zea mays (Maize)': "4577",
                    'Escherichia coli (E. coli)': "83333",
                    'Candida albicans (C. albicans)': "237561",
                    'Dictyostelium discoideum (Dictyostelium)': "44689",
                    'Methanocaldococcus jannaschii (M. jannaschii)': "243232",
                    'Leishmania infantum (L. infantum)': "5671",
                    'Staphylococcus aureus (S. aureus)': "93061",
                    'Trypanosoma cruzi (T. cruzi)': "353153",
                    'Mycobacterium tuberculosis (M. tuberculosis)': "83332",
                    'Saccharomyces cerevisiae (Budding yeast)': "559292",
                    'Schizosaccharomyces pombe (Fission yeast)': "284812",
                    'Plasmodium falciparum (P. falciparum)': "36329",
                },
                options_organsim: [
                    {
                        value: "Homo sapiens (Human)",
                        label: "Homo sapiens (Human)",
                    },
                    {
                        value: "Mus musculus (Mouse)",
                        label: "Mus musculus (Mouse)",
                    },
                    {
                        value: "Rattus norvegicus (Rat)",
                        label: "Rattus norvegicus (Rat)",
                    },
                    {
                        value: "Danio rerio (Zebrafish)",
                        label: "Danio rerio (Zebrafish)",
                    },
                    {
                        value: "Caenorhabditis elegans (Nematode worm)",
                        label: "Caenorhabditis elegans (Nematode worm)",
                    },
                    {
                        value: "Drosophila melanogaster (Fruit fly)",
                        label: "Drosophila melanogaster (Fruit fly)",
                    },
                    {
                        value: "Arabidopsis thaliana (Arabidopsis)",
                        label: "Arabidopsis thaliana (Arabidopsis)",
                    },
                    {
                        value: "Glycine max (Soybean)",
                        label: "Glycine max (Soybean)",
                    },
                    {
                        value: "Oryza sativa (Asian rice)",
                        label: "Oryza sativa (Asian rice)",
                    },
                    {
                        value: "Zea mays (Maize)",
                        label: "Zea mays (Maize)",
                    },
                    {
                        value: "Escherichia coli (E. coli)",
                        label: "Escherichia coli (E. coli)",
                    },
                    {
                        value: "Candida albicans (C. albicans)",
                        label: "Candida albicans (C. albicans)",
                    },
                    {
                        value: "Dictyostelium discoideum (Dictyostelium)",
                        label: "Dictyostelium discoideum (Dictyostelium)",
                    },
                    {
                        value: "Methanocaldococcus jannaschii (M. jannaschii)",
                        label: "Methanocaldococcus jannaschii (M. jannaschii)",
                    },
                    {
                        value: "Leishmania infantum (L. infantum)",
                        label: "Leishmania infantum (L. infantum)",
                    },
                    {
                        value: "Staphylococcus aureus (S. aureus)",
                        label: "Staphylococcus aureus (S. aureus)",
                    },
                    {
                        value: "Trypanosoma cruzi (T. cruzi)",
                        label: "Trypanosoma cruzi (T. cruzi)",
                    },
                    {
                        value: "Mycobacterium tuberculosis (M. tuberculosis)",
                        label: "Mycobacterium tuberculosis (M. tuberculosis)",
                    },
                    {
                        value: "Saccharomyces cerevisiae (Budding yeast)",
                        label: "Saccharomyces cerevisiae (Budding yeast)",
                    },
                    {
                        value: "Schizosaccharomyces pombe (Fission yeast)",
                        label: "Schizosaccharomyces pombe (Fission yeast)",
                    },
                    {
                        value: "Plasmodium falciparum (P. falciparum)",
                        label: "Plasmodium falciparum (P. falciparum)",
                    },
                ],
                value_organsim: "Homo sapiens (Human)",
                blast_res: {}
            };
        },
        created() {
            var date = new Date();
            this.jobid = `${date.getFullYear()}_${date.getMonth()}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}_${randomString(10)}`
            this.upload_url = `${this.website}/api/files/${this.jobid}-query.fasta`
            // console.log(this.upload_url)
        },
        mounted() {

        },
        filters: {
            score_color(color_data) {
                let color = "";
                color_data = color_data['hsps'][0]['score'];
                if (color_data >= 200) {
                    color = "#f45151";
                } else if (color_data < 200 && color_data >= 80) {
                    color = "#f999b0";
                } else if (color_data < 80 && color_data >= 50) {
                    color = "#90ed7d";
                } else if (color_data < 50 && color_data >= 40) {
                    color = "#7cb5ec";
                } else if (color_data < 40) {
                    color = "#434348";
                }
                return {float: 'right', fontSize: '18px', color: color, opacity: 0.8};
            }
        },
        watch: {
            protein_seq(data) {
                if (data != "") {
                    this.fileList = []
                }
            },
            max_target_sequences_val(val) {
                this.more_params[0] = val
            },
            expect_threshold_val(val) {
                this.more_params[1] = val
            },
            word_size_val(val) {
                this.more_params[2] = val
            },
            gap_costs_val(val) {
                this.more_params[3] = val
            },
            matrix_val(val) {
                this.more_params[4] = val
            },
            low_comlexity_regions(val) {
                this.more_params[5] = val.toString();
            },
            mask_for_lookup_table_only(val) {
                this.more_params[6] = val.toString();
            },
            mask_lower_case_letters(val) {
                this.more_params[7] = val.toString();
            },
            hits_chart_height(val) {
                // console.log(val);
                if (val !== '0px') {
                    this.moreChart();
                }
            }
        },
        methods: {
            hit_color(color_data) {
                let color = "";
                if (color_data >= 200) {
                    color = "#f45151";
                } else if (color_data < 200 && color_data >= 80) {
                    color = "#f999b0";
                } else if (color_data < 80 && color_data >= 50) {
                    color = "#90ed7d";
                } else if (color_data < 50 && color_data >= 40) {
                    color = "#7cb5ec";
                } else if (color_data < 40) {
                    color = "#434348";
                }
                return color;
            },
            moreChart() {
                if (this.chart) {
                    this.chart.destroy();
                }
                Highcharts.createElement('link', {
                    href: 'http://fonts.googleapis.com/css?family=Dosis:400,600',
                    rel: 'stylesheet',
                    type: 'text/css'
                }, null, document.getElementsByTagName('head')[0]);
                Highcharts.theme = {
                    colors: ["#7cb5ec", "#f7a35c", "#90ee7e", "#7798BF", "#aaeeee", "#ff0066", "#eeaaee",
                        "#55BF3B", "#DF5353", "#7798BF", "#aaeeee"
                    ],
                    chart: {
                        backgroundColor: null,
                        style: {
                            fontFamily: "Dosis, sans-serif"
                        }
                    },
                    title: {
                        style: {
                            fontSize: '16px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase'
                        }
                    },
                    tooltip: {
                        // borderWidth: 0,
                        backgroundColor: 'rgba(219,219,216,0.6)',
                        // shadow: false
                        // backgroundColor: '#FCFFC5',   // 背景颜色
                        borderColor: 'rgba(219,219,216)', // 边框颜色
                        borderRadius: 10, // 边框圆角
                        borderWidth: 1, // 边框宽度
                        // shadow: ture,                 // 是否显示阴影
                        // animation: true               // 是否启用动画效果
                        style: { // 文字内容相关样式
                            color: 'black',
                            fontSize: "12px",
                            fontWeight: "blod",
                            fontFamily: "Courir new"
                        }
                    },
                    legend: {
                        itemStyle: {
                            fontWeight: 'bold',
                            fontSize: '13px'
                        }
                    },
                    xAxis: {
                        gridLineWidth: 1,
                        labels: {
                            style: {
                                fontSize: '12px'
                            }
                        }
                    },
                    yAxis: {
                        minorTickInterval: 'auto',
                        title: {
                            style: {
                                textTransform: 'uppercase'
                            }
                        },
                        labels: {
                            style: {
                                fontSize: '12px'
                            }
                        }
                    },
                    plotOptions: {
                        candlestick: {
                            lineColor: '#404048'
                        }
                    },
                    background2: '#F0F0EA'
                };
                Highcharts.setOptions(Highcharts.theme);
                // 初始化 Highcharts 图表
                let hits = this.blast_res['BlastOutput2'][0]['report']['results']['search']['hits'];
                let title = "Distribution of " + hits.length + " Blast Hits on the Query Sequence";
                let y_categories = [];
                let data = [];
                let subtitle = "";
                // for (let i = hits.length; i > 0; i--) {
                //     let item = hits[i];
                //     let accession = item["description"][0]["title"].split("|")[1];
                //     item['hsps'].forEach((hsp)=>{
                //         data.push({
                //             x: hsp['query_from'],
                //             x2: hsp['query_to'],
                //             y: i,
                //             color: this.hit_color(hsp['score'])
                //         })
                //     });
                //     y_categories.push(accession)
                // }
                // console.log(hits)
                let hits_length = hits.length - 1;
                hits.forEach((item, i) => {
                    let accession = item["description"][0]["title"].split("|")[2];
                    item['hsps'].forEach((hsp) => {
                        data.push({
                            x: hsp['query_from'],
                            x2: hsp['query_to'],
                            y: hits_length - i,
                            color: this.hit_color(hsp['score'])
                        })
                    });
                    y_categories.push(accession)
                });
                y_categories = y_categories.reverse();
                data = data.reverse();
                document.getElementById('container').innerHTML = '<div id="container_blast" style="height: ' + this.hits_chart_height + ';"></div>';
                this.chart = new Highcharts.Chart('container_blast', {
                    chart: {
                        type: 'xrange'
                    },
                    title: {
                        text: title
                    },
                    subtitle: {
                        text: subtitle
                    },
                    legend: {
                        enabled: false
                    },
                    credits: {
                        enabled: false
                    },
                    xAxis: {},
                    yAxis: {
                        title: {
                            text: ''
                        },
                        categories: y_categories,
                    },
                    tooltip: {},
                    series: [{
                        name: '',
                        // pointPadding: 10000,
                        // groupPadding: 10000,
                        // borderColor: 'gray',
                        pointWidth: 10,
                        data: data,
                        dataLabels: {
                            enabled: true
                        }
                    }],
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            point: {
                                events: {
                                    click: function (val) {
                                        // alert(this.category);
                                        // console.log(val, this.yCategory, this.series.data);
                                        location.href = "#" + this.yCategory;
                                    }
                                }
                            }
                        }
                    },
                });
                this.loading2 = false;
            },
            restart() {
                this.active = 0
                this.fileList = []
                this.protein_seq = "Label,SOX2,POU5F1,NANOG,DPPA5,GATA2,DLX3,ZSCAN4,ERVFRD-1\n3,4,29,71,15724,26,1,2210,14\n3,68,10,45,4509,3,0,767,1\n4,62,133,6,1369,0,0,0,0\n4,178,323,30,1934,0,20,28,0\n5,34,305,7,44,997,244,0,0\n5,0,79,8,88,191,53,0,0\n6,0,104,15,41,316,25,0,63\n6,7,16,1,6,337,57,0,8\n7,0,39,0,1,2598,1653,0,254\n7,143,31,13,60,1566,1252,0,388\n"
                var date = new Date();
                this.jobid = `${date.getFullYear()}_${date.getMonth()}_${date.getDate()}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}_${randomString(10)}`
                this.upload_url = `${this.website}/api/files/${this.jobid}-genes.txt`
            },
            reset() {
                this.fileList = []
                this.protein_seq = "Label,SOX2,POU5F1,NANOG,DPPA5,GATA2,DLX3,ZSCAN4,ERVFRD-1\n3,4,29,71,15724,26,1,2210,14\n3,68,10,45,4509,3,0,767,1\n4,62,133,6,1369,0,0,0,0\n4,178,323,30,1934,0,20,28,0\n5,34,305,7,44,997,244,0,0\n5,0,79,8,88,191,53,0,0\n6,0,104,15,41,316,25,0,63\n6,7,16,1,6,337,57,0,8\n7,0,39,0,1,2598,1653,0,254\n7,143,31,13,60,1566,1252,0,388\n"
            },
            next_step() {
                this.active = 1
                this.previewTable()
            },
            previous_step() {
                this.active = 0
            },
            submit() {
                let vue_obj = this;
                if (this.protein_seq.length > 0) {
                    let url = `${this.website}/api/files/${this.jobid}-query.fasta`;
                    // console.log(url);
                    axios.post(url, {
                        content: this.protein_seq,
                    }, {
                        headers: {
                            // 'Access-Control-Allow-Headers': 'XMLHttpRequest, X_FILENAME, accept-encoding, authorization, content-type, dnt, origin, user-agent, x-csrftoken, x-requested-with',
                            // 'Access-Control-Allow-Methods':'DELETE, GET, OPTIONS, PATCH, POST, PUT, VIEW',
                        }
                    })
                        .then(function (response) {
                            // console.log(response);
                            vue_obj.alignProcess();
                        })
                        .catch(function (error) {
                            // console.log(error);
                        });
                }
            },
            alignProcess() {
                this.active = 2;
                this.loading2 = true;
                // console.log(this.seq_id_val, this.protein_db_val, this.value_organsim, this.value_algorithm, this.more_params);
                "http://183.175.59.23:8002/api/align/blastp/1e-5%7C1/2021_7_17_17_51_51_kTh7KhHjck/"
                let more_params = this.more_params.join("|");
                let algorithm = this.value_algorithm.split(" ")[0];
                let organism = this.organsim_map[this.value_organsim];
                let protein_db_val = this.protein_db_map[this.protein_db_val];
                let seq_id = this.seq_id_val.replace("/", "$$");
                let url = `${this.website}/api/align/${algorithm}/${seq_id}/${organism}/${protein_db_val}/${more_params}/${this.jobid}/`;
                // console.log(url);
                let vue_obj = this;
                axios.get(url).then((res) => {
                    // console.log(res.data.results)
                    vue_obj.blast_res = res.data.results;
                    let hits = res.data.results['BlastOutput2'][0]['report']['results']['search']['hits'];
                    vue_obj.hits_chart_height = 80 + hits.length * 20 + 'px';
                })
            },

            beforeAvatarUpload(file) {
                file
            },
            handleAvatarSuccess(res, file) {
                this.file_url = URL.createObjectURL(file.raw);
                this.protein_seq = ""
            },
            handleRemove(file, fileList) {
                // console.log(file, fileList);
            },
            previewTable() {
                this.loading1 = true;
                this.seq_id_options = [];
                try {
                    if (this.file_url != "") {
                        axios.get(this.file_url).then(res => {
                            var lines = res.data.split("\n")
                            lines.forEach((line) => {
                                if (line.substring(0, 1) === ">") {
                                    line = line.substring(1, line.length);
                                    this.seq_id_options.push({
                                        value: `${line}`,
                                        label: `${line}`,
                                    });
                                }
                            });
                            this.seq_id_val = this.seq_id_options[0]['value'];
                            this.loading1 = false;
                        })
                    } else if (this.protein_seq != "") {
                        let lines = this.protein_seq.split("\n")
                        lines.forEach((line) => {
                            if (line.substring(0, 1) === ">") {
                                line = line.substring(1, line.length);
                                this.seq_id_options.push({
                                    value: `${line}`,
                                    label: `${line}`,
                                });
                            }
                        });
                        this.seq_id_val = this.seq_id_options[0]['value'];
                        this.loading1 = false;
                    }
                } catch {
                    // console.log(">>>")
                }

            },
            //   handlePreview(file) {
            //     console.log(file);
            //   },
            handleExceed(files) {
                this.$message.warning(`A gene matrix file has been uploaded: ${files[0].name}`);
            },
            beforeRemove(file) {
                return this.$confirm(`Are you sure to remove ${file.name}？`);
            }
        }
    };

    function randomString(len) {
        len = len || 32;
        var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
        /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
        var maxPos = $chars.length;
        var pwd = '';
        for (var i = 0; i < len; i++) {
            pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
    }
</script>

<style>
    .legend {
        height: 25px;
        color: #fff;
        padding-top: 2px;
        text-shadow: 1px 1px 5px #292929;
    }

    .el-collapse {
        border-top: none !important;
        border-bottom: none !important;

    }

    .el-collapse-item__header {
        font-size: 28px;
        border-top: none !important;
        border-bottom: none !important;
    }

    .el-collapse-item__wrap {
        border-bottom: none !important;
    }

    .el-form .el-select {
        width: 100%;
    }

    .baimo-step .el-divider__text {
        font-size: 18px;
    }

    .el-upload__input {
        display: none !important;
    }

    .el-switch__label {
        width: 135px;
    }

    .el-switch {
        margin-bottom: 10px;
    }

    /* 分割线配置 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    .el-divider__text,
    .el-link {
        font-weight: 500;
        font-size: 14px;
    }

    .el-divider--horizontal {
        display: block;
        height: 1px;
        width: 100%;
        margin: 10px 0 20px 0 !important;
    }

    .el-divider__text.is-left {
        left: 0px !important;
        transform: translateY(-50%);
    }

    .el-divider__text {
        position: absolute;
        background-color: #fff;
        padding: 0 5px 0px 0px !important;
        color: #303133;
    }

    /* 分割线配置 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< */
    /* 输入框 配置 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/

    /* 输入框 配置 <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<*/

    .el-aside {
        background-color: #ffffff !important;
        border-right: 1px dashed #dddddd;
    }

    .baimoc-toolbar > .baimoc-toolbar-btn-first-child {
        border-bottom-left-radius: 4px;
        border-top-left-radius: 4px;
        border-right-width: 0px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        /*margin-left: -2px;*/
    }

    .baimoc-toolbar > .baimoc-toolbar-btn-first-child:focus,
    .baimoc-toolbar > .baimoc-toolbar-btn-first-child:hover {
        color: #606266;
    }

    .baimoc-toolbar > .el-dropdown > .baimoc-toolbar-btn-first-child {
        color: red;
        border-left-width: 0px;
        border-right-width: 0px;
        border-right-width: 0px;
        border-radius: 0px;
        border-right-color: red;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        /*margin-left: -2px;*/
    }

    .baimoc-toolbar > .el-dropdown > .baimoc-toolbar-btn {
        border-left-width: 0px;
        border-right-width: 0px;
        border-radius: 0px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        /*margin-left: -2px;*/
    }

    .baimoc-toolbar > .el-dropdown > .baimoc-toolbar-btn-last-child {
        border-top-left-radius: 0;
        border-right-width: 1px;
        border-left-width: 0px;
        border-bottom-right-radius: 4px;
        border-top-right-radius: 4px;
        border-right-color: #dcdfe6;
    }
</style>
